import angular from 'angular';
import pqrsListComponent from './pqrs-list.component';
import pqrsListService from './pqrs-list.service';
import pqrsListConfig from './pqrs-list.config';

let pqrsListModule = angular.module('app.pqrsList',[])
  .component('pqrsList', pqrsListComponent)
  .service('pqrsListService', pqrsListService)
  .config(pqrsListConfig);

export default pqrsListModule;






/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/pqrs-list/pqrs-list.js
 **/